import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './SummaryPage.css'
import Content from '../Content'
import EmailSummary from '../EmailSummary'

import Insights from '@healthwise-ui/content/Insights'
import Modal from '@healthwise-ui/core/Modal'
import Button from '@healthwise-ui/core/Button'

const currentLocationLabel = 'summary'

class SummaryPage extends Component {
  constructor(props) {
    super(props)

    this.onQuestionRender = this.onQuestionRender.bind(this)
    this.onEmail = this.onEmail.bind(this)
    this.onPrint = this.onPrint.bind(this)
    this.getEmailModal = this.getEmailModal.bind(this)

    this.decideTopics = this.props.esdpMap.topics[4]
    this.summaryTopics = this.props.esdpMap.topics[5]
    this.recordedResponses = this.props.responseState.responses
    this.insights = new Insights()

    this.state = { showEmailModal: false }
  }

  getSvg(name) {
    switch (name) {
      case 'check':
        return (
          <svg
            role="presentation"
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 95.5 95.5"
            className={styles.svg_check}
          >
            <g>
              <polygon points="43.77 57.24 31.91 45.13 27.76 49.03 44.11 65.94 70.23 33.3 65.77 29.73 43.77 57.24" />
              <path d="M48.74,3.78a44.06,44.06,0,1,0,44.32,43.8A44.11,44.11,0,0,0,48.74,3.78Zm.49,84.46A40.4,40.4,0,1,1,89.39,47.6,40.44,40.44,0,0,1,49.23,88.23Z" />
            </g>
          </svg>
        )
      case 'email':
        return '<svg role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 23"><g fill="none"><path d="M2.885 21.77C2.643 21.77 2.416 21.711 2.211 21.613L11.541 12.283 12.635 13.377 19.365 13.377 20.462 12.28 30.102 21.412C29.831 21.633 29.49 21.77 29.115 21.77L2.885 21.77ZM1.311 2.885C1.311 2.643 1.371 2.416 1.469 2.211L10.799 11.541 1.469 20.871C1.371 20.666 1.311 20.439 1.311 20.197L1.311 2.885ZM29.115 1.311C29.357 1.311 29.584 1.371 29.789 1.469L18.93 12.328 13.07 12.328 2.211 1.469C2.416 1.371 2.643 1.311 2.885 1.311L29.115 1.311ZM21.204 11.538L30.531 2.211C30.629 2.416 30.689 2.643 30.689 2.885L30.689 20.197C30.689 20.298 30.677 20.398 30.658 20.495L21.204 11.538ZM29.115 0.262L2.885 0.262C1.439 0.262 0.262 1.439 0.262 2.885L0.262 20.197C0.262 21.643 1.439 22.82 2.885 22.82L29.115 22.82C30.561 22.82 31.738 21.643 31.738 20.197L31.738 2.885C31.738 1.439 30.561 0.262 29.115 0.262L29.115 0.262Z" fill="#FFF"/><path d="M2.885 21.77C2.643 21.77 2.416 21.711 2.211 21.613L11.541 12.283 12.635 13.377 19.365 13.377 20.462 12.28 30.102 21.412C29.831 21.633 29.49 21.77 29.115 21.77L2.885 21.77 2.885 21.77ZM1.311 2.885C1.311 2.643 1.371 2.416 1.469 2.211L10.799 11.541 1.469 20.871C1.371 20.666 1.311 20.439 1.311 20.197L1.311 2.885 1.311 2.885ZM29.115 1.311C29.357 1.311 29.584 1.371 29.789 1.469L18.93 12.328 13.07 12.328 2.211 1.469C2.416 1.371 2.643 1.311 2.885 1.311L29.115 1.311 29.115 1.311ZM21.204 11.538L30.531 2.211C30.629 2.416 30.689 2.643 30.689 2.885L30.689 20.197C30.689 20.298 30.677 20.398 30.658 20.495L21.204 11.538 21.204 11.538ZM29.115 0.262L2.885 0.262C1.439 0.262 0.262 1.439 0.262 2.885L0.262 20.197C0.262 21.643 1.439 22.82 2.885 22.82L29.115 22.82C30.561 22.82 31.738 21.643 31.738 20.197L31.738 2.885C31.738 1.439 30.561 0.262 29.115 0.262L29.115 0.262Z" stroke="#FFF"/></g></svg>'
      case 'print':
        return '<svg role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" version="1.1"><g style="fill-rule:evenodd;fill:none"><path d="M5.42372881 12.7457627C4.67471186 12.7457627 4.06779661 13.352678 4.06779661 14.1016949 4.06779661 14.8507119 4.67471186 15.4576271 5.42372881 15.4576271 6.17274576 15.4576271 6.77966102 14.8507119 6.77966102 14.1016949 6.77966102 13.352678 6.17274576 12.7457627 5.42372881 12.7457627" fill="#fff"/><path d="M5.42372881 12.7457627C4.67471186 12.7457627 4.06779661 13.352678 4.06779661 14.1016949 4.06779661 14.8507119 4.67471186 15.4576271 5.42372881 15.4576271 6.17274576 15.4576271 6.77966102 14.8507119 6.77966102 14.1016949 6.77966102 13.352678 6.17274576 12.7457627 5.42372881 12.7457627L5.42372881 12.7457627Z" stroke="#fff"/><path d="M30.6440678 21.9661017C30.6440678 22.8631864 29.9140339 23.5932203 29.0169492 23.5932203L25.220339 23.5932203 25.220339 20.3389831 26.8474576 20.3389831C27.1473898 20.3389831 27.3898305 20.096 27.3898305 19.7966102 27.3898305 19.4972203 27.1473898 19.2542373 26.8474576 19.2542373L25.220339 19.2542373 6.77966102 19.2542373 5.15254237 19.2542373C4.85261017 19.2542373 4.61016949 19.4972203 4.61016949 19.7966102 4.61016949 20.096 4.85261017 20.3389831 5.15254237 20.3389831L6.77966102 20.3389831 6.77966102 23.5932203 2.98305085 23.5932203C2.0859661 23.5932203 1.3559322 22.8631864 1.3559322 21.9661017L1.3559322 11.6610169C1.3559322 10.7639322 2.0859661 10.0338983 2.98305085 10.0338983L6.77966102 10.0338983 25.220339 10.0338983 29.0169492 10.0338983C29.9140339 10.0338983 30.6440678 10.7639322 30.6440678 11.6610169L30.6440678 21.9661017ZM7.86440678 30.1016949L24.1355932 30.1016949 24.1355932 20.3389831 7.86440678 20.3389831 7.86440678 30.1016949ZM7.86440678 8.94915254L24.1355932 8.94915254 24.1355932 1.3559322 7.86440678 1.3559322 7.86440678 8.94915254ZM29.0169492 8.94915254L25.220339 8.94915254 25.220339 0.271186441 6.77966102 0.271186441 6.77966102 8.94915254 2.98305085 8.94915254C1.48772881 8.94915254 0.271186441 10.1656949 0.271186441 11.6610169L0.271186441 21.9661017C0.271186441 23.4614237 1.48772881 24.6779661 2.98305085 24.6779661L6.77966102 24.6779661 6.77966102 31.1864407 25.220339 31.1864407 25.220339 24.6779661 29.0169492 24.6779661C30.5122712 24.6779661 31.7288136 23.4614237 31.7288136 21.9661017L31.7288136 11.6610169C31.7288136 10.1656949 30.5122712 8.94915254 29.0169492 8.94915254L29.0169492 8.94915254Z" fill="#fff"/><path d="M30.6440678 21.9661017C30.6440678 22.8631864 29.9140339 23.5932203 29.0169492 23.5932203L25.220339 23.5932203 25.220339 20.3389831 26.8474576 20.3389831C27.1473898 20.3389831 27.3898305 20.096 27.3898305 19.7966102 27.3898305 19.4972203 27.1473898 19.2542373 26.8474576 19.2542373L25.220339 19.2542373 6.77966102 19.2542373 5.15254237 19.2542373C4.85261017 19.2542373 4.61016949 19.4972203 4.61016949 19.7966102 4.61016949 20.096 4.85261017 20.3389831 5.15254237 20.3389831L6.77966102 20.3389831 6.77966102 23.5932203 2.98305085 23.5932203C2.0859661 23.5932203 1.3559322 22.8631864 1.3559322 21.9661017L1.3559322 11.6610169C1.3559322 10.7639322 2.0859661 10.0338983 2.98305085 10.0338983L6.77966102 10.0338983 25.220339 10.0338983 29.0169492 10.0338983C29.9140339 10.0338983 30.6440678 10.7639322 30.6440678 11.6610169L30.6440678 21.9661017 30.6440678 21.9661017ZM7.86440678 30.1016949L24.1355932 30.1016949 24.1355932 20.3389831 7.86440678 20.3389831 7.86440678 30.1016949ZM7.86440678 8.94915254L24.1355932 8.94915254 24.1355932 1.3559322 7.86440678 1.3559322 7.86440678 8.94915254ZM29.0169492 8.94915254L25.220339 8.94915254 25.220339 0.271186441 6.77966102 0.271186441 6.77966102 8.94915254 2.98305085 8.94915254C1.48772881 8.94915254 0.271186441 10.1656949 0.271186441 11.6610169L0.271186441 21.9661017C0.271186441 23.4614237 1.48772881 24.6779661 2.98305085 24.6779661L6.77966102 24.6779661 6.77966102 31.1864407 25.220339 31.1864407 25.220339 24.6779661 29.0169492 24.6779661C30.5122712 24.6779661 31.7288136 23.4614237 31.7288136 21.9661017L31.7288136 11.6610169C31.7288136 10.1656949 30.5122712 8.94915254 29.0169492 8.94915254L29.0169492 8.94915254Z" stroke="#fff"/><path d="M11.1186441 27.3898305L20.8813559 27.3898305C21.1812881 27.3898305 21.4237288 27.1468475 21.4237288 26.8474576 21.4237288 26.5480678 21.1812881 26.3050847 20.8813559 26.3050847L11.1186441 26.3050847C10.8187119 26.3050847 10.5762712 26.5480678 10.5762712 26.8474576 10.5762712 27.1468475 10.8187119 27.3898305 11.1186441 27.3898305" fill="#fff"/><path d="M11.1186441 27.3898305L20.8813559 27.3898305C21.1812881 27.3898305 21.4237288 27.1468475 21.4237288 26.8474576 21.4237288 26.5480678 21.1812881 26.3050847 20.8813559 26.3050847L11.1186441 26.3050847C10.8187119 26.3050847 10.5762712 26.5480678 10.5762712 26.8474576 10.5762712 27.1468475 10.8187119 27.3898305 11.1186441 27.3898305L11.1186441 27.3898305Z" stroke="#fff"/><path d="M11.1186441 26.1355932L20.8813559 26.1355932C21.1812881 26.1355932 21.4237288 25.8926102 21.4237288 25.5932203 21.4237288 25.2938305 21.1812881 25.0508475 20.8813559 25.0508475L11.1186441 25.0508475C10.8187119 25.0508475 10.5762712 25.2938305 10.5762712 25.5932203 10.5762712 25.8926102 10.8187119 26.1355932 11.1186441 26.1355932" fill="#fff"/><path d="M11.1186441 24.1355932L20.8813559 24.1355932C21.1812881 24.1355932 21.4237288 23.8926102 21.4237288 23.5932203 21.4237288 23.2938305 21.1812881 23.0508475 20.8813559 23.0508475L11.1186441 23.0508475C10.8187119 23.0508475 10.5762712 23.2938305 10.5762712 23.5932203 10.5762712 23.8926102 10.8187119 24.1355932 11.1186441 24.1355932L11.1186441 24.1355932Z" stroke="#fff"/></g></svg>'
      case 'reset':
        return '<svg role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><polygon points="23.3629091 -7.27272727e-05 23.3629091 23.3641455 0 23.3641455 0 -7.27272727e-05"/></defs><g><path d="M11.6818182-0.0000727272727C14.8076364-0.0000727272727 17.7734545 1.26610909 19.9392727 3.42392727L23.3632727-0.0000727272727 23.3632727 10.0777455 13.3509091 10.0777455 17.58 5.81592727C16.0330909 4.27410909 13.9138182 3.35410909 11.6818182 3.35410909 7.08109091 3.35410909 3.33781818 7.08938182 3.33781818 11.6901091 3.33781818 16.2908364 7.08109091 20.0297455 11.6818182 20.0297455 14.6512727 20.0297455 17.4207273 18.4290182 18.9101818 15.8544727L21.7996364 17.5250182C19.7152727 21.1272 15.8381818 23.3642909 11.6818182 23.3642909 5.24036364 23.3642909-0.000363636364 18.1228364-0.000363636364 11.6821091 -0.000363636364 5.24138182 5.24036364-0.0000727272727 11.6818182-0.0000727272727" fill="#FFF"/></g></svg>'
      default:
        return null
    }
  }

  onQuestionRender(questionId) {
    const props = this.props
    const recordedResponse = this.props.responseState.responses[questionId]

    if (!recordedResponse) {
      // this is all to create the URL
      let urlParts = props.router.getCurrentLocation().pathname
      urlParts = urlParts.split('/')
      urlParts.pop()
      const topicBase = urlParts.join('/') + '/'
      const decideTopicId = this.decideTopics.id
      const hashLink = topicBase + decideTopicId + '#q_' + questionId

      return (
        <p>
          <a
            tabIndex="0"
            onClick={function(e) {
              e.preventDefault()
              props.router.push(hashLink)
            }}
            onKeyDown={function(e) {
              if (e.keyCode == 13) {
                e.preventDefault()
                props.router.push(hashLink)
              }
            }}
            className={styles.go_back_link}
          >
            Go back to choose an answer...
          </a>
        </p>
      )
    } else if (recordedResponse.type === 'hwSingleSelectOpinion') {
      // clean up the html in this property
      let answer = recordedResponse.answer.value
      answer = answer.replace('<div>', '').replace('</div>', '')

      return (
        <p
          className={
            'hw-summary-page-answered-mult-choice ' +
            styles.answered_mult_choice
          }
        >
          {this.getSvg('check')}
          <span dangerouslySetInnerHTML={{ __html: answer }} />
        </p>
      )
    }
  }

  onEmail(e) {
    e.preventDefault()
    e.stopPropagation()

    this.setState({ showEmailModal: true })

    this.insights.trackEvent({
      pageName: document.title,
      eventName: 'pageAction',
      actionName: 'emailModalOpened',
      actionContext: 'Summary'
    })
  }

  onPrint(e) {
    e.preventDefault()
    e.stopPropagation()

    const esdp = this.props.esdpMap
    const summary = esdp.topics[5]

    this.insights.trackEvent({
      pageName: document.title,
      eventName: 'documentPrinted',
      documentHwid: summary.type,
      documentType: 'esdp',
      documentTitle: summary.title.consumer,
      docLanguage: esdp.lang
    })

    window && window.print()
  }

  navigateToTab(zeroBasedNavIndex) {
    const nav = this.props.esdpMap.navigation.topics

    let urlParts = this.props.router.location.pathname
    urlParts = urlParts.split('/')
    urlParts.pop()

    const newUrl = urlParts.join('/') + '/' + nav[zeroBasedNavIndex].id

    this.props.router.push(newUrl)
    window.scrollTo(0, 0)
  }

  getButtons() {
    switch (this.props.topic.type) {
      case 'decisionSummary':
        const bgEmailStyles = {
          backgroundImage:
            "url('data:image/svg+xml;base64," +
            window.btoa(this.getSvg('email')) +
            "')",
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '30px center',
          paddingLeft: '64px',
          backgroundSize: '28px 28px'
        }
        const bgPrintStyles = {
          backgroundImage:
            "url('data:image/svg+xml;base64," +
            window.btoa(this.getSvg('print')) +
            "')",
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '30px center',
          paddingLeft: '64px',
          backgroundSize: '28px 28px'
        }

        return (
          <div>
            <Button 
              style={bgEmailStyles} 
              onClick={this.onEmail}
              aria-label="Email a copy of your summary to help you talk about your decision"
            >
              Email
            </Button>
            <Button 
              style={bgPrintStyles} 
              onClick={this.onPrint}
              aria-label="Print a copy of your summary to help you talk about your decision"
            >
              Print
            </Button>
          </div>
        )
      default:
        return null
    }
  }

  getEmailModal() {
    const { appMeta, setSummaryEmailStatus } = this.props

    return (
      <Modal
        aria={{ describedby: 'emailSummary_heading' }}
        disableBackdropClick={true}
        open={this.state.showEmailModal}
        title="Email summary"
        showTitle={false}
        showActions={false}
        maxWidth="md"
      >
        <EmailSummary
          emailSuccess={appMeta.summaryEmailSuccess}
          setEmailStatus={setSummaryEmailStatus}
          esdpMap={this.props.esdpMap}
          responses={this.props.responseState.responses}
          onCancel={() => {
            this.insights.trackEvent({
              pageName: document.title,
              eventName: 'pageAction',
              actionName: 'emailModalCancelled',
              actionContext: 'Summary'
            })

            this.setState({ showEmailModal: false })
          }}
          onOkay={() => {
            this.setState({ showEmailModal: false })
          }}
          onSend={emailFields => {
            this.props.emailEsdpSummary(emailFields)
          }}
        />
      </Modal>
    )
  }

  render() {
    // get the relevant question groups (decision assessments from the Decide tab)
    let questionGroupsData = this.decideTopics.topics.filter(function(obj) {
      return obj.type === 'hwDecisionAssessment'
    })

    let newQuestionGroupsData = [
      questionGroupsData[2],
      questionGroupsData[0],
      questionGroupsData[1]
    ]
    questionGroupsData = newQuestionGroupsData

    // if the open answer hasn't been answered or has a blank answer, don't output it
    const openQuestionId = questionGroupsData[2].content[0].interactions[0].id
    if (
      !this.recordedResponses[openQuestionId] ||
      !this.recordedResponses[openQuestionId].answer.value.trim().length
    ) {
      questionGroupsData.pop()
    }

    const questionGroups = questionGroupsData.map((contentItem, order) => {
      return (
        <Content
          key={contentItem.id}
          item={contentItem}
          onQuestionRender={this.onQuestionRender}
          location={currentLocationLabel}
          sectionIndex={1}
          data-page-order={order + 1}
          readonly
        />
      )
    })

    const mediaServiceInfo = this.props.mediaServiceInfo

    // handling the order for each topic in a more manual way, since they are improperly ordered
    const titleTopicData = this.summaryTopics.topics[0]
    const galleryTopicData = this.summaryTopics.topics[2]

    const ctaTopicData = this.summaryTopics.topics[1]
    const titleTopic = (
      <Content
        key={titleTopicData.id}
        item={titleTopicData}
        location={currentLocationLabel}
        sectionIndex={0}
      />
    )
    const ctaTopic = (
      <Content
        key={ctaTopicData.id}
        item={ctaTopicData}
        actionButtons={this.getButtons()}
        location={currentLocationLabel}
        sectionIndex={2}
      />
    )
    const galleryTopic = (
      <Content
        key={galleryTopicData.id}
        item={galleryTopicData}
        isSummary
        location={currentLocationLabel}
        sectionIndex={3}
        mediaServiceUrl={mediaServiceInfo.mediaServiceUrl}
        mediaHash={mediaServiceInfo.mediaHash}
        mediaToken={mediaServiceInfo.mediaToken}
      />
    )

    return (
      <section className={styles.content_section}>
        {titleTopic}
        {questionGroups}
        {ctaTopic}
        {galleryTopic}
        {this.getEmailModal()}
      </section>
    )
  }
}

SummaryPage.propTypes = {
  router: PropTypes.object,
  appMeta: PropTypes.object,
  mediaServiceInfo: PropTypes.object,
  esdpMap: PropTypes.object.isRequired,
  responseState: PropTypes.object.isRequired,
  topic: PropTypes.shape({
    title: PropTypes.shape({
      consumer: PropTypes.string.isRequired
    }).isRequired,
    type: PropTypes.string
  }).isRequired,
  emailEsdpSummary: PropTypes.func,
  setSummaryEmailStatus: PropTypes.func
}

export default SummaryPage



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/SummaryPage/index.js